/* Major 9 — eigen thema. Geen afhankelijkheden. */
(function () {
  'use strict';
  var R = (window.M9 && window.M9.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search/suggest', root: '/' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lastFocus = null;

  /* ---------- Dag / nacht ---------- */
  function setScheme(s) {
    document.documentElement.setAttribute('data-scheme', s);
    try { localStorage.setItem('m9-scheme', s); } catch (e) {}
    syncScheme();
  }
  function syncScheme() {
    var dark = document.documentElement.getAttribute('data-scheme') === 'dark';
    $$('[data-scheme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      if (b.classList.contains('scheme')) b.setAttribute('aria-label', dark ? 'Schakel naar dagmodus' : 'Schakel naar nachtmodus');
    });
    var m = $('meta[name="theme-color"]');
    if (m) m.setAttribute('content', dark ? '#000000' : '#FFFFFF');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scheme-toggle]');
    if (!b) return;
    setScheme(document.documentElement.getAttribute('data-scheme') === 'dark' ? 'light' : 'dark');
  });

  /* ---------- Lades ---------- */
  function openDrawer(el, opener) {
    if (!el) return;
    lastFocus = opener || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var p = $('.drawer__panel', el) || el;
    setTimeout(function () { p.focus({ preventScroll: true }); }, 30);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search.is-open')) document.body.classList.remove('is-locked');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function cartDrawer() { return $('#CartDrawer'); }
  function openCart(opener) { openDrawer(cartDrawer(), opener); }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(document.getElementById(o.getAttribute('data-open')), o); return; }
    var c = e.target.closest('[data-open-cart]');
    if (c && cartDrawer() && document.body.className.indexOf('t-cart') === -1) { e.preventDefault(); openCart(c); return; }
    var x = e.target.closest('[data-close]');
    if (x) { closeDrawer(x.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = $('.drawer.is-open'); if (d) closeDrawer(d);
    closeSearch(); closeMega();
    $$('details.filt[open]').forEach(function (f) { f.open = false; });
  });
  // Focus binnen een open lade houden
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var box = $('.drawer.is-open .drawer__panel') || $('.search.is-open .search__panel');
    if (!box) return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', box).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Megamenu ---------- */
  function closeMega() {
    var b = $('[data-mega]'); var m = $('#Mega'); var s = $('[data-mega-scrim]');
    if (!b || !m) return;
    b.setAttribute('aria-expanded', 'false'); m.hidden = true; if (s) s.hidden = true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mega]');
    if (b) {
      var m = $('#Mega'), s = $('[data-mega-scrim]');
      var open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      m.hidden = !open; if (s) s.hidden = !open;
      if (open) { var a = $('a', m); if (a) a.focus({ preventScroll: true }); }
      return;
    }
    if (e.target.closest('[data-mega-scrim]') || (!e.target.closest('#Mega') && $('#Mega') && !$('#Mega').hidden)) closeMega();
  });

  /* ---------- Zoeken ---------- */
  var searchTimer, searchCtrl;
  function openSearch(opener) {
    var s = $('#Search'); if (!s) return;
    lastFocus = opener || document.activeElement;
    s.classList.add('is-open'); s.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var i = $('[data-pred-input]', s); if (i) setTimeout(function () { i.focus(); }, 30);
  }
  function closeSearch() {
    var s = $('#Search'); if (!s || !s.classList.contains('is-open')) return;
    s.classList.remove('is-open'); s.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-search]'); if (o) { e.preventDefault(); openSearch(o); return; }
    if (e.target.closest('[data-close-search]')) closeSearch();
  });
  document.addEventListener('input', function (e) {
    var i = e.target.closest('[data-pred-input]'); if (!i) return;
    clearTimeout(searchTimer);
    var q = i.value.trim();
    var out = $('[data-pred-results]');
    if (out && !out._empty) { var em = $('[data-pred-empty]', out); out._empty = em ? em.outerHTML : ''; }
    if (q.length < 2) { if (searchCtrl) searchCtrl.abort(); if (out && out._empty) out.innerHTML = out._empty; return; }
    searchTimer = setTimeout(function () {
      if (searchCtrl) searchCtrl.abort();
      searchCtrl = window.AbortController ? new AbortController() : null;
      var url = R.search + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,article,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, searchCtrl ? { signal: searchCtrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var sec = d.getElementById('shopify-section-predictive-search');
        out.innerHTML = sec ? sec.innerHTML : html;
      }).catch(function () {});
    }, 220);
  });

  /* ---------- Winkelwagen ---------- */
  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var d = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = d.getElementById('CartDrawer');
    var cur = cartDrawer();
    if (!fresh || !cur) return;
    var wasOpen = cur.classList.contains('is-open');
    cur.innerHTML = fresh.innerHTML;
    cur.setAttribute('data-count', fresh.getAttribute('data-count'));
    if (wasOpen) { cur.classList.add('is-open'); cur.setAttribute('aria-hidden', 'false'); }
    updateCount(fresh.getAttribute('data-count'));
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-open-cart]').forEach(function (el) { el.setAttribute('aria-label', 'Winkelwagen, ' + n + ' artikelen'); });
  }
  function toast(form, msg) {
    var t = $('[data-form-error]', form.parentNode) || $('[data-form-error]');
    if (t) { t.textContent = msg; t.hidden = false; }
    else alert(msg);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    var err = $('[data-form-error]', form.parentNode); if (err) err.hidden = true;
    fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        if (!res.ok || res.j.status) {
          toast(form, (res.j && (res.j.description || res.j.message)) || 'Dat lukte niet. Probeer het nog eens.');
          return;
        }
        renderDrawer(res.j.sections);
        if (btn && btn.classList.contains('card__add')) {
          btn.classList.add('is-added'); btn.textContent = 'Toegevoegd ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2200);
        }
        if (document.body.className.indexOf('t-cart') > -1) { window.location.reload(); return; }
        openCart(btn);
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); form.removeAttribute('data-add'); form.submit(); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line][data-qty]');
    if (!b) return;
    e.preventDefault();
    var wrap = b.closest('#CartDrawer, [data-cart-page]');
    if (wrap) wrap.classList.add('is-loading');
    fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10), sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (b.closest('[data-cart-page]')) { window.location.reload(); return; }
      if (wrap) wrap.classList.remove('is-loading');
      if (j.status) { alert(j.description || j.message); return; }
      renderDrawer(j.sections);
    }).catch(function () { window.location.href = R.cart; });
  });

  /* ---------- Productpagina ---------- */
  function money(c) {
    var v = (c / 100).toFixed(2).replace('.', ',');
    return '€' + v;
  }
  function initProduct(root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = $('form[data-add]', root) || $('form[data-product-form]', root);
    function current() {
      var opts = [];
      $$('[data-opt]', root).forEach(function (fs) {
        var c = $('input:checked', fs); opts.push(c ? c.value : null);
      });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) if (v.options[k] !== opts[k]) ok = false;
        if (ok) return v;
      }
      return null;
    }
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-opt]')) return;
      var v = current();
      var idInput = form && $('input[name="id"]', form);
      var btn = form && $('[type="submit"]', form);
      var priceEl = $('[data-price]', root), wasEl = $('[data-was]', root), stockEl = $('[data-stock]', root);
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Niet leverbaar'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) { wasEl.textContent = v.compare > v.price ? money(v.compare) : ''; }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (v.pre ? 'Pre-order plaatsen' : 'In winkelwagen') : 'Uitverkocht'; }
      if (stockEl) {
        stockEl.className = 'stock';
        if (!v.available) { stockEl.classList.add('is-out'); stockEl.textContent = 'Nu niet op voorraad'; }
        else if (v.tracked && v.qty > 0 && v.qty <= 3) { stockEl.classList.add('is-low'); stockEl.textContent = v.qty === 1 ? 'Laatste exemplaar' : 'Nog maar ' + v.qty + ' op voorraad'; }
        else if (v.tracked && v.qty <= 0) { stockEl.classList.add('is-pre'); stockEl.textContent = 'Nabestelbaar · levertijd een paar dagen'; }
        else { stockEl.textContent = stockEl.getAttribute('data-instock') || 'Op voorraad'; }
      }
      var sticky = $('[data-sticky-price]'); if (sticky) sticky.textContent = money(v.price);
      var third = $('[data-third]', root); if (third) third.textContent = money(Math.floor(v.price / 3));
      var vt = $('[data-variant-title]', root); if (vt) vt.textContent = v.title;
      var q = $('input[name="quantity"]', root); if (q) { if (v.tracked && v.policy === 'deny') q.max = v.qty; else q.removeAttribute('max'); }
      if (v.media) showMedia(root, v.media);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (er) {}
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]'); if (!t) return;
      showMedia(root, t.getAttribute('data-thumb'));
    });
  }
  function showMedia(root, id) {
    var main = $('[data-main-media]', root), t = $('[data-thumb="' + id + '"]', root);
    if (!main || !t) return;
    var img = $('img', t);
    var big = $('img', main);
    if (img && big) { big.src = img.getAttribute('data-full') || img.src; big.removeAttribute('srcset'); big.alt = img.alt; big.style.transform = img.style.getPropertyValue('--z') || ''; }
    $$('[data-thumb]', root).forEach(function (n) { n.setAttribute('aria-current', n === t ? 'true' : 'false'); });
  }

  /* Aantal-stepper */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var i = $('input', b.closest('[data-qty-box]')); if (!i) return;
    var n = (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
    var max = i.max ? parseInt(i.max, 10) : 99;
    i.value = Math.max(1, Math.min(n, max));
  });

  /* Recent bekeken */
  function saveRecent(el) {
    try {
      var item = JSON.parse(el.textContent);
      var list = JSON.parse(localStorage.getItem('m9-recent') || '[]').filter(function (x) { return x.url !== item.url; });
      list.unshift(item);
      localStorage.setItem('m9-recent', JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }
  function renderRecent(box) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('m9-recent') || '[]'); } catch (e) {}
    var skip = box.getAttribute('data-skip');
    list = list.filter(function (x) { return x.url !== skip; }).slice(0, 4);
    if (!list.length) return;
    var grid = $('[data-recent-list]', box);
    grid.innerHTML = list.map(function (x) {
      var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      return '<a href="' + esc(x.url) + '">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="pred__ph" style="width:64px;height:64px"></span>') +
        '<span><span style="display:block;font-weight:600;font-size:15px;line-height:1.25">' + esc(x.title) + '</span><span class="muted" style="font-size:13px">' + esc(x.price) + ' · ' + esc(x.stock) + '</span></span></a>';
    }).join('');
    box.hidden = false;
  }

  /* Luisteren: Tidal pas laden na klik (privacy + snelheid) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-embed]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-embed-box]') || b.parentNode;
    var f = document.createElement('iframe');
    f.src = b.getAttribute('data-embed');
    f.setAttribute('allow', 'encrypted-media; autoplay');
    f.setAttribute('title', b.getAttribute('aria-label') || 'Speler');
    f.style.minHeight = b.getAttribute('data-h') || '320px';
    f.loading = 'lazy';
    box.innerHTML = ''; box.appendChild(f);
  });

  /* Fragment-speler: zoekt zelf een nummer van de plaat (30 sec. via Apple Music), pas na een klik */
  var pv = { audio: null, key: null, timer: null };
  function pvButtons() { return $$('[data-preview]'); }
  function pvSet(label, sub, playing) {
    pvButtons().forEach(function (b) { b.classList.toggle('is-playing', !!playing); b.setAttribute('aria-pressed', playing ? 'true' : 'false'); });
    $$('[data-preview-label]').forEach(function (l) { if (label) l.textContent = label; });
    var s = $('[data-preview-sub]'); if (s && sub) s.textContent = sub;
  }
  function pvFind(artist, album, cb) {
    if (window.M9find) { window.M9find(artist, album).then(function (l) { cb(l || []); }, function () { cb([]); }); return; }
    cb([]);
  }
  function norm(x) { return String(x || '').toLowerCase().replace(/\(.*?\)|\[.*?\]/g, '').replace(/[^a-z0-9à-ÿ ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  var pvCache = {};
  function pvPick(res, artist, album) {
    var a = norm(artist).split(' ')[0], al = norm(album);
    var ok = res.filter(function (r) { return r.previewUrl && norm(r.artistName).indexOf(a) > -1; });
    var exact = ok.filter(function (r) { var c = norm(r.collectionName); return c && al && (c.indexOf(al) > -1 || al.indexOf(c) > -1); });
    var pool = exact.length ? exact : ok;
    return pool.filter(function (r) { return (r.trackTimeMillis || 0) > 90000 && !/intro|interlude|skit/i.test(r.trackName); })[0] || pool[0] || false;
  }
  function pvLookup(key, cb) {
    if (pvCache[key] !== undefined && pvCache[key] !== null) { cb(pvCache[key]); return; }
    var parts = key.split('|');
    pvCache[key] = null;
    pvFind(parts[0], parts[1] || '', function (res) { pvCache[key] = pvPick(res, parts[0], parts[1] || ''); cb(pvCache[key]); });
  }
  function pvStart(el, key, t) {
    if (pv.audio && pv.audio !== el) pv.audio.pause();
    pv.audio = el; pv.key = key;
    if (!el.__pv) {
      el.__pv = true;
      el.addEventListener('timeupdate', function () { var bar = $('[data-preview-bar]'); if (bar && el.duration && el.src.indexOf('data:') !== 0) bar.style.width = (el.currentTime / el.duration * 100) + '%'; });
      el.addEventListener('ended', function () { if (el.src.indexOf('data:') !== 0) pvSet('Nog een keer', null, false); });
    }
    el.src = t.previewUrl;
    var pr = el.play();
    pvSet(t.trackName, t.artistName + ' · fragment van 30 seconden', true);
    if (pr && pr.catch) pr.catch(function () { pvSet('Tik nog een keer om te luisteren', null, false); pv.key = null; });
  }
  // Zoek het nummer alvast op, zodat een tik op de knop direct kan afspelen (nodig op iPhone)
  function pvPrefetch() { var b = pvButtons()[0]; if (b && !b.getAttribute('data-preview-url')) pvLookup(b.getAttribute('data-preview'), function () {}); }
  if (document.readyState === 'complete') setTimeout(pvPrefetch, 600); else window.addEventListener('load', function () { setTimeout(pvPrefetch, 600); });
  document.addEventListener('shopify:section:load', function () { setTimeout(pvPrefetch, 600); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-preview]'); if (!b) return;
    e.preventDefault();
    var key = b.getAttribute('data-preview');
    if (pv.audio && pv.key === key) {
      if (pv.audio.paused) { pv.audio.play(); pvSet(null, null, true); } else { pv.audio.pause(); pvSet(null, null, false); }
      return;
    }
    var el = new Audio();
    if (b.getAttribute('data-preview-url')) { pvStart(el, key, { previewUrl: b.getAttribute('data-preview-url'), trackName: b.getAttribute('data-preview-track') || 'Fragment', artistName: key.split('|')[0] }); return; }
    var c = pvCache[key];
    if (c) { pvStart(el, key, c); return; }
    if (c === false) { pvSet('Geen fragment gevonden', 'Probeer het later nog eens', false); return; }
    // Nog niet bekend: geluid alvast ontgrendelen binnen de tik, daarna zoeken
    if (window.M9_SILENT) { el.src = window.M9_SILENT; var up = el.play(); if (up && up.catch) up.catch(function () {}); }
    if (pv.audio) pv.audio.pause();
    pvSet('Even zoeken…', null, true);
    pvLookup(key, function (t) {
      if (!t) { pvSet('Geen fragment gevonden', 'Probeer het later nog eens', false); return; }
      pvStart(el, key, t);
    });
  });

  /* Sticky koopbalk */
  function initSticky() {
    var bar = $('[data-sticky-buy]'), target = $('[data-buy-anchor]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }).observe(target);
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sticky-go]')) return;
      var f = $('[data-product] form[data-add] [type="submit"]');
      if (f && !f.disabled) f.click(); else target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ---------- Collectie: filters zonder herladen ---------- */
  function collectionUrl(form) {
    var fd = new FormData(form), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
    return window.location.pathname + '?' + p.toString();
  }
  function loadCollection(url, push) {
    var sec = $('[data-col-section]');
    if (!sec) { window.location.href = url; return; }
    var id = sec.getAttribute('data-col-section');
    var res = $('[data-results]', sec); if (res) res.classList.add('is-loading');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var fresh = d.querySelector('[data-col-section]');
      if (fresh) sec.innerHTML = fresh.innerHTML; else window.location.href = url;
      if (push) history.pushState({ col: true }, '', url);
    }).catch(function () { window.location.href = url; });
  }
  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-filters]');
    if (!f || e.target.matches('[data-price-input]')) return;
    loadCollection(collectionUrl(f), true);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-filters]');
    if (!f) return; e.preventDefault(); loadCollection(collectionUrl(f), true);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-col-link]');
    if (!a) return; e.preventDefault(); loadCollection(a.getAttribute('href'), true);
    var t = $('[data-col-section]'); if (t && a.closest('.pager')) t.scrollIntoView({ behavior: 'smooth' });
  });
  // Laad meer: volgende pagina onder de huidige plakken
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-load-more]');
    if (!a) return;
    var sec = $('[data-col-section]'); if (!sec) return;
    e.preventDefault();
    a.classList.add('is-loading'); a.textContent = 'Laden…';
    var url = a.getAttribute('href');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec.getAttribute('data-col-section')).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-grid]', sec), fresh = d.querySelector('[data-grid]');
      if (grid && fresh) $$('.card', fresh).forEach(function (c) { grid.appendChild(c); });
      var pg = $('.pager', sec), npg = d.querySelector('.pager');
      if (pg) { if (npg) pg.outerHTML = npg.outerHTML; else pg.remove(); }
      var cnt = $('.toolbar .count strong', sec), ncnt = d.querySelector('.toolbar .count strong');
      if (cnt && ncnt) cnt.textContent = ncnt.textContent;
    }).catch(function () { window.location.href = url; });
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.col) loadCollection(window.location.href, false); });
  // Klik buiten een filter sluit hem
  document.addEventListener('click', function (e) {
    $$('details.filt[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
  // Slechts één filter tegelijk open
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('details.filt') || !e.target.open) return;
    $$('details.filt[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
  }, true);

  /* Uitgelicht-slider */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slide]');
    if (!b) return;
    var box = b.closest('[data-slider]'), track = $('[data-track]', box);
    var dir = b.getAttribute('data-slide') === 'next' ? 1 : -1;
    var w = track.clientWidth, max = track.scrollWidth - w;
    var to = track.scrollLeft + dir * w;
    if (to > max + 5) to = 0; if (to < -5) to = max;
    track.scrollTo({ left: to, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-track]')) return;
    var box = t.closest('[data-slider]'), n = $('[data-slide-n]', box);
    if (n) n.textContent = Math.round(t.scrollLeft / t.clientWidth) + 1;
  }, true);

  /* Begrippenlijst: tooltips in productteksten */
  function glossaryTips() {
    var src = document.getElementById('glossary-data');
    var targets = $$('[data-glossary]');
    if (!src || !targets.length) return;
    var terms = src.textContent.split('\n').map(function (l) { l = l.trim(); var i = l.indexOf('='); if (!l || l[0] === '#' || i < 1) return null; return { t: l.slice(0, i).trim(), d: l.slice(i + 1).trim() }; }).filter(Boolean);
    terms.sort(function (a, b) { return b.t.length - a.t.length; });
    targets.forEach(function (root) {
      var used = {};
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (!node.nodeValue.trim() || node.parentNode.closest('a, abbr, script, style, h1, h2, h3')) return;
        for (var i = 0; i < terms.length; i++) {
          var term = terms[i]; if (used[term.t]) continue;
          var re = new RegExp('(^|[^\\wÀ-ÿ])(' + term.t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')(?=$|[^\\wÀ-ÿ])', 'i');
          var m = re.exec(node.nodeValue); if (!m) continue;
          var start = m.index + m[1].length;
          var after = node.splitText(start); after.splitText(m[2].length);
          var ab = document.createElement('abbr'); ab.className = 'gl-tip'; ab.title = term.d; ab.textContent = after.nodeValue;
          after.parentNode.replaceChild(ab, after);
          used[term.t] = true; break;
        }
      });
    });
  }

  /* ---------- Start ---------- */
  function measureHeader() {
    var h = $('.hdr-wrap');
    if (h) document.documentElement.style.setProperty('--hdr-h', h.offsetHeight + 'px');
  }
  function reveal() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.sec-head, .grid > .card, .genre, .post, .music__feat, .music__item, .staff, .rule, .story-card, .blog-feat, .tile-story').forEach(function (el, i) {
      if (el.classList.contains('reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) return;
      el.classList.add('reveal');
      el.style.transitionDelay = ((i % 4) * 60) + 'ms';
      io.observe(el);
    });
  }
  function init() {
    syncScheme();
    measureHeader(); reveal();
    window.addEventListener('resize', measureHeader);
    $$('[data-product]').forEach(initProduct);
    var r = $('[data-recent-save]'); if (r) saveRecent(r);
    $$('[data-recent]').forEach(renderRecent);
    initSticky();
    glossaryTips();
    if (window.location.hash === '#notify') { var n = $('#notify'); if (n) n.scrollIntoView(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: na herladen van secties opnieuw initialiseren
  document.addEventListener('shopify:section:load', init);
})();
